console.log("B2B hooks")
window.bssB2BHooks = window.bssB2BHooks || {
    actions: {},
    filters: {},
};

window.BSS_B2B = window.BSS_B2B || {};

window.BSS_B2B.addAction = (tag, callback) => {
    window.bssB2BHooks.actions[tag] = callback;
}
window.BSS_B2B.addFilter = (tag,  value) => {
    window.bssB2BHooks.filters[tag] = value;
}
function handleDuplicateCheckoutButton({ checkoutButton }) {
    const defaultBtnCheckout = $(checkoutButton).parent().find("button[name='checkout'], #checkout")
    if (defaultBtnCheckout.length > 0) {
        defaultBtnCheckout.css("display", "none")
        $("#bss-checkout, [name='bss-checkout']").css("display", "block")
    }
}

function handleComparePriceOnMiniCart({ originalPrice, item, modifiedLineItemPrice }) {
    let newOriginalPriceHTML = '<span class="bss-b2b-compare-at-price" bss-b2b-compare-price style="text-decoration: line-through">' +
        BSS_B2B.formatMoney(originalPrice * item.quantity) + '</span>';
    $('[bss-b2b-cart-item-key="' + item.key + '"][bss-b2b-final-line-price]').
        html(newOriginalPriceHTML + BSS_B2B.formatMoney(modifiedLineItemPrice));
}

window.BSS_B2B.addAction('handle_duplicate_checkout', handleDuplicateCheckoutButton);
window.BSS_B2B.addAction('compare_price_mini_cart', handleComparePriceOnMiniCart);